export const MS_PER_SECOND = 1000
export const SECONDS_PER_MINUTE = 60
export const MINUTES_PER_HOUR = 60
export const HOURS_PER_DAY = 24
export const POLL_INTERVAL_MINUTES = 5
export const FETCH_INTERVAL_MS =
  POLL_INTERVAL_MINUTES * SECONDS_PER_MINUTE * MS_PER_SECOND
